import { Col, Row, Modal } from 'react-bootstrap';
import { Button } from "primereact/button";
import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Avatar } from 'primereact/avatar';
import { getSocket } from "../context/socket";
import { useAuth } from '../context/AuthContext';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';

const LinkSection = ({ section, cardId }) => {
    const { userId } = useAuth();
    const [showCommentId, setShowCommentId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [editModalData, setEditModalData] = useState(null);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const socket = getSocket();

    const handleAddComment = (link) => {
        socket.emit("add_card_comment", {
            card_id: cardId,
            card_section_id: section.section_id,
            reference_id: link.link_id,
            comment_type: "link",
            comment_text: commentText,
            user_id: userId
        });

        setCommentText('');
    };

    const handleResolveComment = (comment_id) => {
        socket.emit("resolve_card_comment", {
            card_id: cardId,
            comment_id,
            user_id: userId
        });

    };

    const handleEditLink = () => {
        const { link_id, title, url } = editModalData;
        socket.emit("edit_section_link", {
            link_id,
            title,
            url,
            user_id: userId,
            card_id: cardId
        });
        setEditModalData(null);
    };

    const handleDeleteLink = (link_id) => {
        socket.emit("delete_section_link", {
            link_id,
            user_id: userId,
            card_id: cardId
        });
        setConfirmDeleteId(null);
    };


    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-link me-2 text-danger"></i> <b>{section.section_name}</b></h6>
            </div>

            <div className='taskdataLink'>
                {section.links.map(link => (
                    <div className={`d-flex align-items-center gap-3 justify-content-between catdHover py-2 ${showCommentId === link.link_id ? 'example-1' : ''}`} key={link.link_id}>
                        <a href={link.url} target="_blank" rel="noopener noreferrer" className='d-flex w-100 justify-content-between align-items-center'>
                            <p className="mb-0 justify-content-between w-100">
                                <span className='text-purple'>{link.title || 'Uploaded Link'}</span>
                                <small className="text-secondary d-block" style={{ fontSize: '12px' }}>
                                    Last Updated:
                                    <span>{new Date(link.updatedAt).toLocaleDateString('en-GB', {
                                        day: '2-digit', month: 'short', year: 'numeric'
                                    })}</span>
                                </small>
                            </p>
                        </a>
                        <div style={{ width: '100px' }} className="d-flex justify-content-end ">
                            <Button
                                tooltip="Edit Link"
                                icon="pi pi-pencil"
                                text severity="secondary"
                                className="border-0 p-0"
                                onClick={() => setEditModalData({ ...link })}
                            />
                            <div className="position-relative">
                                <Button
                                    icon="pi pi-comments"
                                    tooltip="Comment"
                                    className="border-0 p-1"
                                    severity='secondary'
                                    text
                                    onClick={() => setShowCommentId(prev => prev === link.link_id ? null : link.link_id)}
                                />
                                {link.comments?.length > 0 && (
                                    <span
                                        style={{
                                            position: 'absolute',
                                            top: '-4px',
                                            right: '1px',
                                            background: 'rgb(255 255 255)',
                                            border: '1px solid rgb(228, 45, 119)',
                                            color: 'rgb(228, 45, 119)',
                                            borderRadius: '50%',
                                            width: '15px',
                                            height: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '9px',
                                            fontWeight: '600'
                                        }}
                                    >
                                        {link.comments.length}
                                    </span>
                                )}
                            </div>

                            <Button
                                tooltip="Delete"
                                icon="pi pi-times"
                                text severity="danger"
                                className="border-0 p-0"
                                onClick={() => setConfirmDeleteId(link.link_id)}
                            />
                        </div>
                    </div>
                ))}
            </div>
            <div className="p-0">
                {/* Comment popup */}
                {showCommentId && (
                    <div className="img-comment mt-3 ">
                        <Button
                            icon="pi pi-times"
                            className="p-button-text cmtclose"
                            style={{
                                position: 'absolute',
                                top: '-9px',
                                right: '-5px',
                                padding: '0px',
                                background: '#ff0000',
                                width: '20px',
                                height: '20px', 
                                borderRadius: '50% !important',
                                left: 'auto',
                                color: '#fff',
                            }}
                            onClick={() => setShowCommentId(null)}
                        />

                        {section.links.find(link => link.link_id === showCommentId)?.comments?.map(comment => (
                            <div
                                key={comment.comment_id}
                                className='d-flex gap-2 comDiv align-items-start mb-2'
                            >
                                <Avatar
                                    image={comment.creator?.profileImage?.image_url}
                                    label={comment.creator?.first_name?.[0]}
                                    shape="circle"
                                />
                                <div className="w-100 position-relative">
                                    <p className="mb-1">
                                        <strong>{comment.creator.first_name} {comment.creator.last_name}</strong>
                                    </p>
                                    <p className="mb-1">{comment.comment_text}</p>
                                    <small className="text-muted d-block mb-2">
                                        {new Date(comment.createdAt).toLocaleString('en-GB', {
                                            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        })}
                                    </small>

                                    <div className="d-flex justify-content-between">
                                        <Button
                                            title="Resolve"
                                            icon="pi pi-check-circle"
                                            severity="secondary"
                                            text
                                            className="p-0"
                                            onClick={() => handleResolveComment(comment.comment_id)}
                                            style={{
                                                position: 'absolute',
                                                background: 'transparent',
                                                top: '-5px',
                                                right: '-5px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>


                        ))}

                        {/* 👇 ADD THIS HERE 👇 */}
                        < div className="mt-3" >
                            <InputTextarea
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                className="px-2 py-1 w-100"
                                placeholder="Add a comment..."
                                rows={2}
                            />
                            <div className="text-end mt-1">
                                <Button
                                    label="Send"
                                    severity="help+"
                                    className="py-1 border-0"
                                    onClick={() =>
                                        handleAddComment(
                                            section.links.find(link => link.link_id === showCommentId)
                                        )
                                    }
                                    disabled={!commentText.trim()}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div >

            {/* Edit Modal */}
            <Dialog
                header="Edit Link"
                visible={!!editModalData}
                onHide={() => setEditModalData(null)}
                style={{ width: '400px' }}
                position="bottomright"
                footer={
                    <div className="d-flex justify-content-end gap-2">
                        <Button label="Cancel" text onClick={() => setEditModalData(null)} />
                        <Button label="Save Changes" icon="pi pi-check" onClick={handleEditLink} />
                    </div>
                }
            >
                <div className="mb-3">
                    <label className="form-label">Title</label>
                    <InputText
                        className="w-100"
                        value={editModalData?.title || ''}
                        onChange={(e) =>
                            setEditModalData(prev => ({ ...prev, title: e.target.value }))
                        }
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">URL</label>
                    <InputText
                        className="w-100"
                        value={editModalData?.url || ''}
                        onChange={(e) =>
                            setEditModalData(prev => ({ ...prev, url: e.target.value }))
                        }
                    />
                </div>
            </Dialog>


            {/* Delete Confirmation Modal */}
            <Dialog
                header="Confirm Delete"
                visible={!!confirmDeleteId}
                onHide={() => setConfirmDeleteId(null)}
                style={{ width: '350px' }}
                position="bottomright"
                footer={
                    <div className="d-flex justify-content-end gap-2">
                        <Button label="Cancel" text onClick={() => setConfirmDeleteId(null)} />
                        <Button
                            label="Delete"
                            icon="pi pi-trash"
                            severity="danger"
                            onClick={() => handleDeleteLink(confirmDeleteId)}
                        />
                    </div>
                }
            >
                <p>Are you sure you want to delete this link?</p>
            </Dialog>


        </>
    );
};

export default LinkSection;
